/**
 * Nearby browse (no q) — directory-style sales-point list (MOCKUP-NEARBY-CARDS).
 */
import { DirectoryResults } from '../../shared/ui/DirectoryResults.js';
import type { FormatDistanceMetersLabels } from '../../shared/ui/directoryListFilter.js';
import { BrowseNearbySalesPointCard } from './BrowseNearbySalesPointCard.js';
import type { DiscoveryIntentSalesPointGroup } from './groupDiscoveryOffersBySalesPoint.js';

export type BrowseNearbySalesPointResultsProps = {
  readonly groups: readonly DiscoveryIntentSalesPointGroup[];
  readonly distanceFormatter: FormatDistanceMetersLabels;
};

export function BrowseNearbySalesPointResults(
  props: BrowseNearbySalesPointResultsProps,
): JSX.Element {
  const { groups, distanceFormatter } = props;

  return (
    <DirectoryResults
      density="list"
      listLayout="inset"
      testId="customer-browse-nearby-sp-results"
      aria-live="polite"
    >
      {groups.map((group, index) => (
        <BrowseNearbySalesPointCard
          key={group.salesPointId}
          group={group}
          index={index}
          distanceFormatter={distanceFormatter}
        />
      ))}
    </DirectoryResults>
  );
}
